export default __webpack_public_path__ + "static/media/plus1.57634eb0.svg";